module.exports = __webpack_public_path__ + "img/nopost.b72f7f11.svg";